export const SET_RULE_DATA = 'setRuleData';
export const CLEAR_RULE_REDUX_STORE = 'clearRuleReduxStore';
